import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { CommunityProfileType, Room } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { RoomService, ToastService, UserBeanService } from '@services';

export const roomResolver: ResolveFn<Room> = async ({
  params,
  queryParams,
}) => {
  const userBeanService = inject(UserBeanService);
  const roomService = inject(RoomService);
  const router = inject(Router);
  const toastService = inject(ToastService);
  const translate = inject(TranslateService);

  const userBean = await userBeanService.getUserBean();
  const { id = '-1' } = params;

  if (userBean.communityProfileId === CommunityProfileType.SIGNING_ROOM) {
    return new RedirectCommand(
      router.createUrlTree(['/home'], { queryParams })
    );
  }

  if (+id === userBean.signingRoomId) {
    return new RedirectCommand(
      router.createUrlTree(['/signingroom'], { queryParams })
    );
  }

  try {
    return await firstValueFrom(roomService.getRoom(+id));
  } catch {
    toastService.show({
      text: translate.instant('WEB_NOTIFY_RESOURCE_DELETE_ERROR_404'),
      type: 'danger',
    });

    return new RedirectCommand(router.parseUrl('/rooms'));
  }
};
